{
  "alexandria": { "short": "Alejandría", "full": "Faro de Alejandría" },
  "babylon": { "short": "Babilonia", "full": "Jardines colgantes de Babilonia" },
  "ephesos": { "short": "Éfeso", "full": "Templo de Artemisa en Éfeso" },
  "gizah": { "short": "Guiza", "full": "Gran Pirámide de Guiza" },
  "halikarnassos": { "short": "Halicarnaso", "full": "Mausoleo de Halicarnaso" },
  "olympia": { "short": "Olimpia", "full": "Estatua de Zeus en Olimpia" },
  "rhodos": { "short": "Rodas", "full": "Coloso de Rodas" },
  "side": { "day": "Día", "night": "Noche" }
}
